import { Overlay } from '@angular/cdk/overlay';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    DestroyRef,
    effect,
    signal,
    Signal,
    WritableSignal,
} from '@angular/core';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { CostObject, ObjectExplorerItem, ObjectExplorerItemType } from 'app/api';
import { DialogBuilderComponent } from 'app/core/dialogBuilder/dialog-builder.component';
import { GridViewsModule, TableColumnDef } from '../../../../../projects/grid-views/src/public-api';
import { ObjectExplorerService } from 'app/modules/object-explorer/object-explorer.service';
import { Translation, TranslocoService } from '@ngneat/transloco';
import { RicefwService } from '../ricefw.service';
import { RicefwResponseDto } from 'app/data-api';

@Component({
    selector: 'select-ricefw-dialog',
    imports: [GridViewsModule],
    templateUrl: './select-ricefw-dialog.component.html',
    styleUrl: './select-ricefw-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: MAT_SELECT_SCROLL_STRATEGY,
            useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.reposition(),
            deps: [Overlay],
        },
    ],
})
export class SelectRicefwDialogComponent extends DialogBuilderComponent<any> {
    _translocoContent = signal(null);

    data: WritableSignal<any> = signal([]);
    displayedColumns: Signal<Array<TableColumnDef>> = computed(() =>
        this.getDisplayedTableColumns(this._translocoContent())
    );
    dataSource: Signal<MatTableDataSource<RicefwResponseDto>>;
    selection: WritableSignal<any[]> = signal([]);

    constructor(
        private objectExplorerService: ObjectExplorerService,
        private riceFwService: RicefwService,
        private _destroy: DestroyRef,
        private _translocoService: TranslocoService
    ) {
        super();
        this._translocoService.selectTranslation('data').subscribe(content => {
            this._translocoContent.set(content);
        });

        this.initializeData();

        this.dataSource = computed(() => {
            return new MatTableDataSource(this.data()) ?? new MatTableDataSource([]);
        });

        effect(() => {
            const code = this.executeActionSignal();

            if (code === 'selectRicefw') {
                if (!this.riceFwService.current()) this.riceFwService.current = {};
                this.riceFwService.current().ricefwInfo['ricefw'] = this.selection()[0];
                this.riceFwService.current().ricefwId = this.selection()[0].id;
                this.closeDialog();
            }
        });
    }

    initializeData(): void {
        const ricefwList = this.objectExplorerService
            .objectExplorerItems()
            .filter(item => item.type === ObjectExplorerItemType.Ricefw);

        let ricefwItems = [];

        ricefwList.forEach(item => {
            item.metadata['ricefw']?.forEach(ricefw => {
                ricefwItems.push(ricefw);
            });
        });

        this.data.set(ricefwItems);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        setTimeout(() => {
            this.selection.set(this.componentData.selection);
        });
    }
    onRowSelected($event: any): void {
        if (!$event[0]) {
            return;
        }
        this.selection.set($event);
    }

    getDisplayedTableColumns(translocoContent: Translation): TableColumnDef[] {
        return [
            {
                columnName: translocoContent['ricefw.name'],
                columnKey: 'type',
                enableSorting: true,
            },
        ];
    }
}
